import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f2d311c4"
import script from "./?vue&type=script&lang=js&external"
export * from "./?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=f2d311c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports